import axios from "../axiosInstance";

const toParams = (searchParams) =>
  searchParams instanceof URLSearchParams ? Object.fromEntries(searchParams.entries()) : searchParams || {};

const PosAPI = {
  products: (params) => axios.get(`/pos/products`, { params: toParams(params) }),
  search: (q, limit = 20) => axios.get(`/pos/search`, { params: { q, limit } }),
  lookup: (code) => axios.get(`/pos/lookup`, { params: { code } }),
  customers: (search) => axios.get(`/pos/customers`, { params: { search } }),
  coupons: () => axios.get(`/pos/coupons`),
  checkCoupon: (payload) => axios.post(`/pos/coupons/check`, payload),

  createSale: (payload) => axios.post(`/pos/sales`, payload),
  listSales: (searchParams) => axios.get(`/pos/sales`, { params: toParams(searchParams) }),
  summary: (params) => axios.get(`/pos/sales/summary`, { params: toParams(params) }),
  getSale: (id) => axios.get(`/pos/sales/${id}`),
  addPayment: (id, payload) => axios.patch(`/pos/sales/${id}/payments`, payload),
  cancelSale: (id, reason) => axios.patch(`/pos/sales/${id}/cancel`, { reason }),
};

export default PosAPI;